import React from "react"
import { Link, graphql } from "gatsby"
import { EmailShareButton, EmailIcon, WhatsappIcon, WhatsappShareButton, FacebookShareButton, FacebookIcon } from "react-share"
import parse from "html-react-parser"

// We're using Gutenberg so we need the block styles
import "../css/@wordpress/block-library/build-style/style.css"
import "../css/@wordpress/block-library/build-style/theme.css"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"

const BlogPostTemplate = ({ data: { previous, next, post } }) => {
  // Extract the featured image URL from GraphQL data
  const featuredImage = post.featuredImage?.node?.publicUrl
  const imageAlt = post.featuredImage?.node?.altText || "Featured Image"

  return (
    <Layout>
      <Seo title={post.title} description={post.excerpt} />

      <div className="container mx-auto px-4 font-inter max-w-3xl">


        <div className="breadcrumbs my-2 font-inter text-sm py-2 text-slate-400 font-semibold">
          <Link className="text-slate-400" to="/">Home </Link> &gt;
          <Link className="text-slate-400" to="/surf-blog">Blog </Link> &gt;
          <Link className="text-slate-800">{post.title} </Link>
        </div>

        <article className="blog-post container" itemScope itemType="http://schema.org/Article">
          <header>
          <h1 className="text-5xl font-oswald uppercase text-center mb-4" itemProp="headline">
  {parse(post.title)}
</h1>

<div className="w-full flex flex-col md:flex-row justify-between items-center mb-4">
  {/* Auteur sectie */}
  <div className="flex items-center space-x-3">
    <img
      src={post.author.node.avatar.url}
      className="rounded-full w-16 h-16 transition-transform transform-gpu hover:scale-110"
      alt={post.author.node.firstName}
      width={80}
      height={80}
    />
    <span className="text-lg text-gray-700">
      Door <strong>{post.author.node.firstName}</strong>
    </span>
  </div>

  {/* Deelknoppen sectie */}
  <div className="flex items-center space-x-2 mt-3 md:mt-0">
    <EmailShareButton subject="Check out this blog post" body="I thought you might find this blog post interesting:" url={`https://surfawhile.com${post.link}`}>
      <EmailIcon size={32} round={true} bgStyle={{ fill: 'black' }} />
    </EmailShareButton>

    <WhatsappShareButton url={`https://surfawhile.com${post.link}`}>
      <WhatsappIcon size={32} round={true} bgStyle={{ fill: 'black' }} />
    </WhatsappShareButton>

    <FacebookShareButton url={`https://surfawhile.com${post.link}`}>
      <FacebookIcon size={32} round={true} bgStyle={{ fill: 'black' }} />
    </FacebookShareButton>
  </div>
</div>

            {/* Display featured image */}
            {featuredImage && (
              <img
                src={`https://www.surfawhile.com/.netlify/images?url=${encodeURIComponent(featuredImage)}&format=webp&w=1200&h=800&fit=crop`} // Use Netlify Image CDN
                alt={imageAlt}
                className="w-full"
                loading="lazy" // Lazy load for better performance
              />
            )}
          </header>

          <section className="font-inter" itemProp="articleBody">
            {parse(post.content)}
          </section>

          <hr />
          {/* Social media buttons again */}
          <div className="w-full flex justify-between mb-1">
           
            <div>
            <EmailShareButton subject="Check out this blog post" body="I thought you might find this blog post interesting:" url={`https://surfawhile.com${post.link}`}>
              <EmailIcon size={32} round={true} bgStyle={{ fill: 'black' }} className="block text-white" />
            </EmailShareButton>

            <WhatsappShareButton url={`https://surfawhile.com${post.link}`}>
              <WhatsappIcon size={32} round={true} bgStyle={{ fill: 'black' }} className="block text-white mx-1" />
            </WhatsappShareButton>

            <FacebookShareButton url={`https://surfawhile.com${post.link}`}>
              <FacebookIcon size={32} round={true} bgStyle={{ fill: 'black' }} className="block text-white" />
            </FacebookShareButton>
          </div>
          </div>
          <footer>
            <Bio author={post.author.node} />
          </footer>
        </article>
      </div>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostById(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    post: wpPost(id: { eq: $id }) {
      id
      excerpt
      content
      title
      link
      author {
        node {
          firstName
          lastName
          description
          avatar {
            url
          }
        }
      }
      date(formatString: "MMMM DD, YYYY")
      featuredImage {
        node {
          publicUrl
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(
                quality: 100
                placeholder: TRACED_SVG
                layout: FULL_WIDTH
              )
            }
          }
        }
      }
    }
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
    }
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`